import { createFileRoute } from "@tanstack/react-router";
import { LocationIndex } from "@/components/prayer/LocationIndex";

export const Route = createFileRoute("/jadwal-imsak/lokasi")({
  head: () => ({
    meta: [
      { title: "Indeks Lokasi Jadwal Imsakiyah - Semua Kota Indonesia" },
      { name: "description", content: "Daftar lengkap provinsi, kota, dan kecamatan di Indonesia untuk jadwal imsakiyah. Pilih lokasi Anda." },
      { property: "og:title", content: "Indeks Lokasi Jadwal Imsakiyah" },
      { property: "og:description", content: "Daftar provinsi, kota & kecamatan untuk jadwal imsakiyah." },
      { property: "og:url", content: "https://hari.co.id/jadwal-imsak/lokasi/" },
      { property: "og:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://hari.co.id/jadwal-imsak/lokasi/" }],
  }),
  component: () => <LocationIndex variant="imsak" />,
});